import React from 'react';
import { withFormsy } from 'formsy-react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import './toggle.css';

// const style = {
//   border: '2px solid #17E685',
//   background: 'none',
// };

class StyledToggle extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(e) {
    this.props.setValue(e.target.checked);
  }

  render() {
    const { getValue, name, style, disabled } = this.props;
    const isChecked = getValue() || false;
    return (
      <div style={style}>
        <label htmlFor={name}>
          <Toggle
            id={name}
            defaultChecked={isChecked}
            icons={false}
            onChange={this.changeValue}
            style={style}
            name={name}
            disabled={disabled}
          />
        </label>
      </div>
    );
  }
}

StyledToggle.defaultProps = {
  placeholder: '',
  label: '',
};

StyledToggle.propTypes = {
  name: PropTypes.string.isRequired,
  getValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default withFormsy(Radium(StyledToggle));



// WEBPACK FOOTER //
// ./src/components/Formsy/StyledToggle/StyledToggle.js